import { useElementVisibility, ELEMENTS } from './useIsElementVisible';
import { useContentLabels } from './useContentLabels';

export const useCanEditLabels = () => {
	const { isElementVisible } = useElementVisibility();
	const { data } = useContentLabels();
	const { hasEditPermissions } = data;
	return isElementVisible(ELEMENTS.ROWS.LABELS) && hasEditPermissions;
};
